import React from 'react';
import * as R from 'ramda';
import { connect } from 'react-redux';
import { replace } from 'redux-little-router';
import { Form, Modal, Layout, Dropdown, Icon, Avatar, Menu, Button } from 'antd';
import { QUERY_COLOR, CATEGORY_COLOR } from './entityColors';
import './Window.less';
import AppTab from './AppTab';
import AppTabGroup from './AppTabGroup';
import entityActions from '../common/genericActions/entityActions';

const mapStateToProps = (state) => {
  const connectionId = R.path(['connection', '/window', 'ids', '0'], state);
  return {
    connectionId,
    tabs: R.pathOr(
      [],
      ['tab', `/connection/${connectionId}`, 'ids'],
      state,
    ).map(id => state.tab.byId[id]),
    router: state.router,
  };
};

const mapDispatchToProps = dispatch => ({
  onClose: id => dispatch(entityActions.releaseKeyWindow(`/tab/${id}`)),
  onOpen: route => dispatch(replace(`/tab/${route}`)),
  onOpenNew: type => dispatch(replace(`/tab?type=${type}`)),
});

class Window extends React.Component {
  handleOpenNew = ({ key }) => {
    const { onOpenNew } = this.props;
    switch (key) {
      case 'category': {
        onOpenNew('category');
        break;
      }
      case 'query':
        onOpenNew('query');
        break;
      default:
    }
  };

  handleClose = (id) => {
    const { onClose } = this.props;
    onClose(id);
  };

  handleOpen = (id) => {
    const { onOpen } = this.props;
    onOpen(id);
  };

  isTabActive(id) {
    const { router } = this.props;
    return router.params && `${id}` === router.params.id;
  }

  renderMenu() {
    return (
      <Menu>
        <Menu.Item key="query" onClick={this.handleOpenNew}>
          <Avatar
            size="small"
            icon="code-o"
            shape="square"
            style={{ background: QUERY_COLOR, marginRight: '8px' }}
          />
          <span>Query</span>
        </Menu.Item>
        <Menu.Item key="category" onClick={this.handleOpenNew}>
          <Avatar
            size="small"
            icon="inbox"
            shape="square"
            style={{ background: CATEGORY_COLOR, marginRight: '8px' }}
          />
          <span>Category</span>
        </Menu.Item>
      </Menu>
    );
  }

  render() {
    const { router, tabs, connectionId, children } = this.props;

    if (connectionId === undefined) {
      return (<div />);
    }

    return (
      <Layout className="vb-light vb-tab_window">
        <div className="vb-tab_window-bar">
          <div className="vb-tab_window-bar-group">
            <div className="vb-tab_window-bar-group-contents">
              {/*
              <AppTab
                key="home"
                id="home"
                isActive={this.isTabActive('home')}
                onOpen={this.handleOpen}
                onClose={this.handleClose}
                type="home"
                isPinned
              />
              */}
              <AppTab
                key="browse"
                id="browse"
                isActive={this.isTabActive('browse')}
                onOpen={this.handleOpen}
                onClose={this.handleClose}
                type="browse"
                isPinned
              />
            </div>
          </div>
          <AppTabGroup
            activeTabId={router.params ? parseInt(router.params.id, 10) : null}
            onOpen={this.handleOpen}
            onClose={this.handleClose}
            tabs={tabs.filter(tab => !tab.isPinned)}
          />
          <div className="vb-tab_window-bar-controls">
            <Dropdown overlay={this.renderMenu()}>
              <Button size="small" icon="plus">
                New
              </Button>
            </Dropdown>
          </div>
        </div>
        <Layout.Content className="vb-tab_window-content">
          { children }
        </Layout.Content>
      </Layout>
    );
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(Window);
